// Angular
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
// Rxjs
import { Subject, combineLatest, of } from 'rxjs';
import { takeUntil, catchError } from 'rxjs/operators';
// Services
import { MenuStateService } from './services/menu-state.service';
import { MenuItem, FirstLevelMenuItem } from './models';
import { CategoryService } from '@core/services-v2/category/services/category.service';
import { MenuApiService } from './services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-categorias',
  templateUrl: './menu-categorias-b2c.component.html',
  styleUrls: ['./menu-categorias-b2c.component.scss'],
})
export class MenuCategoriasComponent implements OnInit, OnDestroy {
  private destroy$: Subject<any> = new Subject();
  menuCategoriesItems: FirstLevelMenuItem[] = [];
  menuItems: MenuItem[] = [];
  isOpen: boolean = false;

  private readonly categoryService: CategoryService = inject(CategoryService);
  public readonly menuStateService: MenuStateService =
    inject(MenuStateService);
  private readonly menuApiService: MenuApiService = inject(MenuApiService);
  private readonly router: Router = inject(Router);

  ngOnInit(): void {
    this.menuStateService.isOpen$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOpen) => (this.isOpen = isOpen));
    this.fetchMenus();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  /**
   * Obtener elementos del menú.
   */
  private fetchMenus(): void {
    const menuItems$ = this.menuApiService.getMenu().pipe(
      catchError((err) => {
        console.error('Error fetching menu items:', err);
        return of([]); // Retorna array vacío si falla
      })
    );

    const categories$ = this.categoryService.getMenuCategories().pipe(
      catchError((err) => {
        console.error('Error fetching categories:', err);
        return of({ items: [] }); // Retorna objeto con items vacío si falla
      })
    );

    combineLatest([menuItems$, categories$])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ([menuItems, categories]) => {
          this.menuItems = menuItems;
          this.menuCategoriesItems = categories.items;
        },
        error: (err) => {
          console.error('Unexpected error in menu loading:', err);
        },
      });
  }
  goToAllProducts(): void {
    this.router.navigate(['/inicio/productos/todos']);
    this.menuStateService.close();
  }
}
